import { createPrivateClient } from './api';

const eventClient = createPrivateClient();

const eventService = {
  send: (msisdn: string, eventData: Record<string, unknown>) =>
    eventClient.post(`/events/${msisdn}`, eventData),
};

export default eventService;
